import { GoToTopBtn } from 'components/GoTopBtn';
import WebLoader from 'components/WebLoader';
import WebBg from 'components/WebBg';
import Home from 'pages/Home';
import Header from 'layout/Header/header';
import Footer from 'layout/Footer/footer';


// ******  Main app wrapper ******
const App = () => {
  console.clear();
  console.warn = () => { };

  return (
    <>
      <Header />
      <Home />
      <Footer />
      <GoToTopBtn />
      <WebLoader />
      <WebBg />
    </>
  )
}

export default App